// src/components/ContactForm.js
import React from 'react';
import { Box, TextField, Typography } from '@mui/material';

export default function ContactForm({ values, onChange }) {
  return (
    <Box sx={{ my: 3 }}>
      <Typography variant="h6" gutterBottom>
        Contact Information
      </Typography>

      <Box
        component="section"
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '20px',
        }}
      >
        {/* Row 1 */}
        <Box sx={{ gridColumn: '1 / span 1', gridRow: '1' }}>
          <TextField
            fullWidth
            label="First Name"
            name="firstName"
            value={values.firstName}
            onChange={onChange}
            required
          />
        </Box>
        <Box sx={{ gridColumn: '2 / span 1', gridRow: '1' }}>
          <TextField
            fullWidth
            label="Last Name"
            name="lastName"
            value={values.lastName}
            onChange={onChange}
            required
          />
        </Box>

        {/* Row 2 */}
        <Box sx={{ gridColumn: '1 / span 1', gridRow: '2' }}>
          <TextField
            fullWidth
            label="Email Address"
            name="email"
            type="email"
            value={values.email}
            onChange={onChange}
            required
          />
        </Box>
        <Box sx={{ gridColumn: '2 / span 1', gridRow: '2' }}>
          <TextField
            fullWidth
            label="Telephone"
            name="telephone"
            type="tel"
            value={values.telephone}
            onChange={onChange}
            required
          />
        </Box>

        {/* Row 3 (spans all 3 columns) */}
        <Box sx={{ gridColumn: '1 / span 2', gridRow: '3' }}>
          <TextField
            fullWidth
            label="Company"
            name="company"
            value={values.company}
            onChange={onChange}
            required
          />
        </Box>

        {/* Row 4 (spans all 3 columns) */}
       
        {/* <Box sx={{ gridColumn: '1 / -1', gridRow: '4' }}>
          <TextField
            fullWidth
            label="Additional Information"
            name="description"
            multiline
            rows={4}
            placeholder="Any extra details (max 1000 chars)"
            inputProps={{ maxLength: 1000 }}
            helperText={`${values.description?.length || 0}/1000`}
            value={values.description}
            onChange={onChange}
          />
        </Box> */}

        <Box sx={{ gridColumn: '1 / -1', gridRow: '4' }}>
          <TextField
            fullWidth
            variant="filled"
            label="Additional Information"
            name="description"
            multiline
            rows={4}
            placeholder="Any extra details (max 1000 characters)"
            inputProps={{ maxLength: 1000 }}
            helperText={`${(values.description?.length || 0)}/1000`}
            value={values.description}
            onChange={onChange}
            InputProps={{
              disableUnderline: true,    // remove the default bottom line
            }}
            sx={{
              // style the filled input root to look like outlined
              '& .MuiFilledInput-root': {
                backgroundColor: 'background.paper',  // white paper
                border: '1px solid',
                borderColor: 'rgba(0, 0, 0, 0.23)',    // default outline color
                borderRadius: 1,
                overflow: 'hidden',
                '&:hover': {
                  borderColor: 'rgba(0, 0, 0, 0.87)', // hover outline
                },
                '&.Mui-focused': {
                  borderColor: 'primary.main',        // focus outline
                  backgroundColor: 'background.paper',
                },
              },
              // ensure the label floats and has correct padding
              '& .MuiFilledInput-input': {
                padding: '6.5px 0px 0.5px',        // match outlined vertical padding
              },
            }}
          />
        </Box>

      </Box>
    </Box>
  );
}